<template>
  <div class="home">
    <van-nav-bar
      title="围栏信息"
      left-text="返回"
      right-text="新建"
      left-arrow
      fixed
      @click-left="$router.push('/home')"
      @click-right="handleAdd"
    />
    <van-empty class="fixed-top" v-if="showEmpty" description="暂未设置围栏，快去设置吧~" />
    <van-pull-refresh class="fixed-top" v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad"
        v-if="list"
      >
        <van-swipe-cell
          v-for="(item, index) in list"
          :key="index"
          style="margin-top: 10px;position:relative;"
        >
          <van-cell :border="false" :title="item.Weilanname"></van-cell>
          <div style="position: absolute;top: 0;right:0;">
            <van-button square type="primary" text="查看" @click="viewFence(item)" />
            <van-button square type="danger" text="删除" @click="deleteFence(item)" />
          </div>
        </van-swipe-cell>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { NavBar, Empty, List, PullRefresh, SwipeCell, Cell, Button, Toast } from 'vant'

export default {
  data() {
    return {
      showEmpty: false,
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      finishedText: '没有更多了'
    }
  },
  mounted() {
    // console.log(localStorage.getItem('studentId'), '123123')
    // var self = this
    // var container = document.getElementById('container')
    // var map = new window.AMap.Map('container', {
    //   resizeEnable: true,
    //   zoom: 14
    // })
  },
  methods: {
    editFence(item) {
      this.$router.push({
        name: 'fenceAdd',
        query: {
          id: item.id
        }
      })
    },

    viewFence(item) {
      localStorage.setItem("currentFence",JSON.stringify(item));
      this.$router.push({
        name: 'fenceAdd',
        query: {
          viewId: item.WeilanID
        }
      })
    },

    deleteFence(item) {
      this.$http
        .json_post(this.$api.studentcard.delweilaninfo, {
          Weilanid: item.WeilanID,
          Deviceid:item.Deviceid
        })
        .then(data => {
          if (data.code == 0) {
            Toast('删除成功')
            this.onRefresh()
          }else{
            Toast(data.msg)
          }
        })
    },

    getFenceList() {
      var sinfo = localStorage.getItem('currentChild');
      var studentinfo = JSON.parse(sinfo);
      this.$http
        .json_post(this.$api.studentcard.getweilanlist, {
          Deviceid: studentinfo.Deviceid
        })
        .then(data => {
          if (data.code == 0) {
            const res = data.data
            const total = data.data.length
            if (total <= 0) {
              this.showEmpty = true
              this.list = []
              this.finished = true
              this.finishedText = ''
              return
            }
          
            this.total = data.data.length
            this.list.push(...res)
            this.loading = false
            this.refreshing = false
            if (this.list.length >= total) {
              this.finished = true
            }
          }else{
            this.loading = false
            Toast(data.msg);
          }
        })
    },

    onRefresh() {
      // 清空列表数据
      this.finished = false
     
      this.list = []

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.refreshing = true
      this.onLoad()
    },

    onLoad() {
      this.getFenceList()
    
    },

    handleAdd() {
      this.$router.push({ name: 'fenceAdd' })
    }
  },
  components: {
    'van-nav-bar': NavBar,
    'van-empty': Empty,
    'van-list': List,
    'van-pull-refresh': PullRefresh,
    'van-swipe-cell': SwipeCell,
    'van-cell': Cell,
    'van-button': Button
  }
}
</script>

<style lang="scss" scoped>
.home,
#container {
  width: 100%;
  height: 100vh;
}
.operat {
  position: fixed;
  bottom: 100px;

  right: 15px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  i {
    width: 50px;
    height: 50px;
    font-size: 18px;
    margin-top: 15px;
    line-height: 50px;
    color: #fff;
    text-align: center;
    background: #40e0d0; /* fallback for old browsers */
    background: -webkit-linear-gradient(
      to right,
      #40e0d0,
      #07c160
    ); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(
      to right,
      #40e0d0,
      #07c160
    ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
    border-radius: 50%;
    &.icon-dingwei1 {
      font-size: 22px;
    }
  }
}
</style>
